function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixFormulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.43,253a10.83,10.83,0,0,1-2.58-.31,10.65,10.65,0,0,1-6.54-4.82l-29.53-48.71a34.81,34.81,0,0,1-31.14-56.48,4,4,0,0,1,3.38-1.46,4,4,0,0,1,3.14,1.92L226.82,164a2.59,2.59,0,0,0,1.62,1.2,2.5,2.5,0,0,0,1.95-.29l6.07-3.68a2.56,2.56,0,0,0,1.17-1.59,2.64,2.64,0,0,0-.32-2l-12.65-20.87a4,4,0,0,1,2.61-6A34.81,34.81,0,0,1,263,184.52l29.53,48.71A10.61,10.61,0,0,1,289,247.81l-6.07,3.68A10.52,10.52,0,0,1,277.43,253ZM240.8,190.8a4,4,0,0,1,3.42,1.93l30.93,51a2.64,2.64,0,0,0,1.63,1.2,2.51,2.51,0,0,0,2-.29L284.8,241a2.58,2.58,0,0,0,1.17-1.6,2.63,2.63,0,0,0-.32-2l-30.93-51a4,4,0,0,1,.32-4.6A26.73,26.73,0,0,0,257.12,151h0a26.81,26.81,0,0,0-22.32-12.92l9.35,15.42a10.61,10.61,0,0,1-3.54,14.58l-6.07,3.68a10.59,10.59,0,0,1-14.56-3.6l-9.35-15.42A26.82,26.82,0,0,0,240,190.89,3.72,3.72,0,0,1,240.8,190.8Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,192.32a26.71,26.71,0,0,1-5.52-16.22V119.62a6.48,6.48,0,0,1,6.47-6.47,4,4,0,0,0,0-8,14.49,14.49,0,0,0-14.47,14.47V176.1a34.79,34.79,0,0,0,7.18,21.1l33.16,43.14a19,19,0,0,1-15,30.51H118.35a19,19,0,0,1-15-30.51l33.17-43.14a34.84,34.84,0,0,0,7.17-21.1V119.62a14.48,14.48,0,0,0-14.47-14.47,4,4,0,0,0,0,8,6.47,6.47,0,0,1,6.47,6.47V176.1a26.76,26.76,0,0,1-5.51,16.22L97,235.46a27,27,0,0,0,21.37,43.39h83.11a27,27,0,0,0,21.38-43.39Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,203.08H146.31a4,4,0,0,0,0,8H173.5a4,4,0,0,0,0-8Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,221.43H146.31a4,4,0,0,0,0,8H173.5a4,4,0,0,0,0-8Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,239.42H146.31a4,4,0,0,0,0,8H173.5a4,4,0,0,0,0-8Z",
    style: {
      fill: "#2ba6de"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixFormulation);
export default __webpack_public_path__ + "static/media/fix-formulation.38f5e77c9be573f308e627444c96d908.svg";
export { ForwardRef as ReactComponent };